var exports = {
  "A": "xa15a2ab7--d84a09--item",
  "w": "xa15a2ab7--d84a09--logo",
};

module.exports = exports;
